
export function PillPagination({
  currentPage,
  pageSize,
  total,
  itemLabel = "items",
  onPageChange,
  pageSizeOptions,
  onPageSizeChange,
}) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));

  const getPageNumbers = () => {
    if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i + 1);
    const pages = [];
    pages.push(1);
    if (currentPage > 3) pages.push("...");
    for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
      pages.push(i);
    }
    if (currentPage < totalPages - 2) pages.push("...");
    pages.push(totalPages);
    return pages;
  };

  const rangeStart = total === 0 ? 0 : (currentPage - 1) * pageSize + 1;
  const rangeEnd = Math.min(currentPage * pageSize, total);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: 10,
        marginTop: 14,
        marginLeft: "auto",
        width: "fit-content",
        padding: "7px 12px",
        background: "#ffffff",
        borderRadius: 18,
        border: "1px solid #e8ecf4",
        boxShadow: "0 2px 8px rgba(15,23,42,0.06)",
      }}
    >
      {/* Previous */}
      <button
        onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        style={{
          display: "flex", alignItems: "center", gap: 4,
          background: "none", border: "none",
          cursor: currentPage === 1 ? "not-allowed" : "pointer",
          color: currentPage === 1 ? "#c8d0df" : "#374151",
          fontSize: 11, fontWeight: 600, padding: "1px 5px", borderRadius: 6,
        }}
      >
        <svg width={14} height={14} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5}>
          <path d="M15 18l-6-6 6-6" />
        </svg>
        Previous
      </button>

      {/* Page numbers */}
      <div style={{ display: "flex", alignItems: "center", gap: 3 }}>
        {getPageNumbers().map((p, i) =>
          p === "..." ? (
            <span key={`ellipsis-${i}`} style={{ color: "#9ca3af", fontSize: 13, padding: "0 4px" }}>
              ···
            </span>
          ) : (
            <button
              key={p}
              onClick={() => onPageChange(p)}
              style={{
                width: 28, height: 28, borderRadius: "50%",
                border: "none", cursor: "pointer",
                background: currentPage === p ? "#1677ff" : "none",
                color: currentPage === p ? "#ffffff" : "#374151",
                fontSize: 11, fontWeight: currentPage === p ? 700 : 500,
                boxShadow: currentPage === p ? "0 2px 8px rgba(22,119,255,0.35)" : "none",
                transition: "all 0.15s",
              }}
            >
              {p}
            </button>
          )
        )}
      </div>

      {/* Next + count */}
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <button
          onClick={() => currentPage < totalPages && onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          style={{
            display: "flex", alignItems: "center", gap: 4,
            background: "none", border: "none",
            cursor: currentPage === totalPages ? "not-allowed" : "pointer",
            color: currentPage === totalPages ? "#c8d0df" : "#374151",
            fontSize: 11, fontWeight: 600, padding: "1px 5px", borderRadius: 6,
          }}
        >
          Next
          <svg width={14} height={14} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5}>
            <path d="M9 18l6-6-6-6" />
          </svg>
        </button>
        <span style={{ fontSize: 10, color: "#6b7280", whiteSpace: "nowrap" }}>
          Showing {rangeStart}–{rangeEnd} of {total} {itemLabel}
        </span>
        {pageSizeOptions && onPageSizeChange && (
          <select
            value={pageSize}
            onChange={(e) => {
              onPageSizeChange(Number(e.target.value));
              onPageChange(1);
            }}
            style={{
              border: "1px solid #e8ecf4",
              background: "#fff",
              color: "#374151",
              borderRadius: 16,
              padding: "1px 7px",
              fontSize: 10,
              cursor: "pointer",
              outline: "none",
            }}
          >
            {pageSizeOptions.map((s) => (
              <option key={s} value={s}>{s} / page</option>
            ))}
          </select>
        )}
      </div>
    </div>
  );
}
